"use strict";
exports.__esModule = true;
var ERROR_UNKNOWN = 'Unknown error';
/**
 *  Makes string from error of any type:
 *    JS exceptions, http responses, text
 *
 * @param err
 * @returns {string}
 */
function extractErrorMessage(err) {
    if (!err) {
        return ERROR_UNKNOWN;
    }
    var message;
    if (typeof err === 'string') {
        message = err;
    }
    else {
        message = err.message || err.responseText;
    }
    if (typeof message === 'string') {
        try {
            var parsed = JSON.parse(message);
            if (parsed && 'message' in parsed && typeof parsed.message === 'string' && parsed.message) {
                message = parsed.message;
            }
        }
        catch (erx) {
            // failed to json-parse
        }
        if (message) {
            if (message.startsWith('<html')) {
                // if html, try to find its header
                try {
                    message.match(/<h1>(.+?)<\/h1>/);
                    var h1Text = RegExp.$1;
                    if (typeof h1Text == 'string') {
                        message = h1Text;
                    }
                }
                catch (err) {
                    //
                }
            }
            return message;
        }
    }
    if ('status' in err) {
        switch (err.status) {
            case 404:
                return 'Network error: 404'; // TODO: find out resource
        }
    }
    console.log('[extractErrorMessage] failed to extract message');
    console.log(err);
    return ERROR_UNKNOWN;
}
exports.extractErrorMessage = extractErrorMessage;
